import React from 'react';
import { IFloatingFilter, IFloatingFilterParams } from 'ag-grid-community';

export const ClientDataBooleanColumnFilter = React.forwardRef<IFloatingFilter, IFloatingFilterParams>(() => <span />);
